const PODUS_API_URL = import.meta.env.VITE_PODUS_API_URL ?? 'https://api-v2.podus.org/api';
const SYSTEM_KEY = 'G@V3l2023-new-podus-v001233-SyS';

function getApiBase(): string {
    const trimmed = PODUS_API_URL.replace(/\/$/, '');
    return trimmed.endsWith('/api') ? trimmed : `${trimmed}/api`;
}

/**
 * Pings NEW_PODUS_API with the given token to confirm it's still valid.
 *
 * Why: when a user logs out (or has their `tokensValidAfter` bumped), the auth
 * service still holds the now-revoked JWT in its own `p-ai-accessToken`
 * cookie. If `/sign-in` blindly auto-redirects with that cookie, the target
 * app rejects the token, redirects back to `/sign-in`, and the user loops.
 *
 * Returns:
 *   true  → token is accepted by the API.
 *   false → token is rejected (revoked, expired, signature mismatch).
 *           Caller should treat the auth-side cookie as stale and clear it.
 */
export async function isTokenValid(token: string): Promise<boolean> {
    if (!token) return false;
    try {
        const res = await fetch(`${getApiBase()}/users/profile`, {
            headers: {
                Authorization: `Bearer ${SYSTEM_KEY}:${token}`,
            },
        });
        if (res.status === 401) return false;
        return res.ok;
    } catch {
        // Network error: don't claim invalid (so we don't gratuitously log
        // people out on a flaky connection) but the caller should likely also
        // not auto-redirect since it can't reach the API to confirm.
        return false;
    }
}
